/* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20130528 */
(function (e) {
    "use strict";
    e(document).on("cycle-bootstrap", function (e, i, t) {
        "carousel" === i.fx && (t.getSlideIndex = function (e) {
            var i = this.opts()._carouselWrap.children(),
                t = i.index(e);
            return t % i.length
        }, t.next = function () {
            var e = i.reverse ? -1 : 1;
            i.allowWrap === !1 && i.currSlide + e > i.slideCount - i.carouselVisible || (i.API.advanceSlide(e), i.API.trigger("cycle-next", [i]))
        })
    }), e.fn.cycle.transitions.carousel = {
        preInit: function (i) {
            i.hideNonActive = !1, i.container.on("cycle-destroyed", e.proxy(this.onDestroy, i.API)), i.API.stopTransition = this.stopTransition;
            for (var t = 0; i.startingSlide > t; t++) i.container.append(i.slides[0])
        },
        postInit: function (i) {
            var t, n, s, o, l = i.carouselVertical;
            i.carouselVisible && i.carouselVisible > i.slideCount && (i.carouselVisible = i.slideCount - 1);
            var r = i.carouselVisible || i.slides.length,
                c = {
                    display: l ? "block" : "inline-block",
                    position: "static"
                };
            if (i.container.css({
                position: "relative",
                overflow: "hidden"
            }), i.slides.css(c), i._currSlide = i.currSlide, o = e('<div class="cycle-carousel-wrap"></div>').prependTo(i.container).css({
                margin: 0,
                padding: 0,
                top: 0,
                left: 0,
                position: "absolute"
            }).append(i.slides), i._carouselWrap = o, l || o.css("white-space", "nowrap"), i.allowWrap !== !1) {
                for (n = 0;
                    (void 0 === i.carouselVisible ? 2 : 1) > n; n++) {
                    for (t = 0; i.slideCount > t; t++) o.append(i.slides[t].cloneNode(!0));
                    for (t = i.slideCount; t--;) o.prepend(i.slides[t].cloneNode(!0))
                }
                o.find(".cycle-slide-active").removeClass("cycle-slide-active"), i.slides.eq(i.startingSlide).addClass("cycle-slide-active")
            }
            i.pager && i.allowWrap === !1 && (s = i.slideCount - r, e(i.pager).children().filter(":gt(" + s + ")").hide()), i._nextBoundry = i.slideCount - i.carouselVisible, this.prepareDimensions(i)
        },
        prepareDimensions: function (i) {
            var t, n, s, o = i.carouselVertical,
                l = i.carouselVisible || i.slides.length;
            if (i.carouselFluid && i.carouselVisible ? i._carouselResizeThrottle || this.fluidSlides(i) : i.carouselVisible && i.carouselSlideDimension ? (t = l * i.carouselSlideDimension, i.container[o ? "height" : "width"](t)) : i.carouselVisible && (t = l * e(i.slides[0])[o ? "outerHeight" : "outerWidth"](!0), i.container[o ? "height" : "width"](t)), n = i.carouselOffset || 0, i.allowWrap !== !1)
                if (i.carouselSlideDimension) n -= (i.slideCount + i.currSlide) * i.carouselSlideDimension;
                else {
                    s = i._carouselWrap.children();
                    for (var r = 0; i.slideCount + i.currSlide > r; r++) n -= e(s[r])[o ? "outerHeight" : "outerWidth"](!0)
                }
            i._carouselWrap.css(o ? "top" : "left", n)
        },
        fluidSlides: function (i) {
            function t() {
                clearTimeout(s), s = setTimeout(n, 20)
            }

            function n() {
                i._carouselWrap.stop(!1, !0);
                var e = i.container.width() / i.carouselVisible;
                e = Math.ceil(e - l), i._carouselWrap.children().width(e), i._sentinel && i._sentinel.width(e), r(i)
            }
            var s, o = i.slides.eq(0),
                l = o.outerWidth() - o.width(),
                r = this.prepareDimensions;
            e(window).on("resize", t), i._carouselResizeThrottle = t, n()
        },
        transition: function (i, t, n, s, o) {
            var l, r = {}, c = i.nextSlide - i.currSlide,
                a = i.carouselVertical,
                d = i.speed;
            if (i.allowWrap === !1) {
                s = c > 0;
                var u = i._currSlide,
                    p = i.slideCount - i.carouselVisible;
                c > 0 && i.nextSlide > p && u == p ? c = 0 : c > 0 && i.nextSlide > p ? c = i.nextSlide - u - (i.nextSlide - p) : 0 > c && i.currSlide > p && i.nextSlide > p ? c = 0 : 0 > c && i.currSlide > p ? c += i.currSlide - p : u = i.currSlide, l = this.getScroll(i, a, u, c), i.API.opts()._currSlide = i.nextSlide > p ? p : i.nextSlide
            } else s && 0 === i.nextSlide ? (l = this.getDim(i, i.currSlide, a), o = this.genCallback(i, s, a, o)) : s || i.nextSlide != i.slideCount - 1 ? l = this.getScroll(i, a, i.currSlide, c) : (l = this.getDim(i, i.currSlide, a), o = this.genCallback(i, s, a, o));
            r[a ? "top" : "left"] = s ? "-=" + l : "+=" + l, i.throttleSpeed && (d = l / e(i.slides[0])[a ? "height" : "width"]() * i.speed), i._carouselWrap.animate(r, d, i.easing, o)
        },
        getDim: function (i, t, n) {
            var s = e(i.slides[t]);
            return s[n ? "outerHeight" : "outerWidth"](!0)
        },
        getScroll: function (e, i, t, n) {
            var s, o = 0;
            if (n > 0)
                for (s = t; t + n > s; s++) o += this.getDim(e, s, i);
            else
                for (s = t; s > t + n; s--) o += this.getDim(e, s, i);
            return o
        },
        genCallback: function (i, t, n, s) {
            return function () {
                var t = e(i.slides[i.nextSlide]).position(),
                    o = 0 - t[n ? "top" : "left"] + (i.carouselOffset || 0);
                i._carouselWrap.css(i.carouselVertical ? "top" : "left", o), s()
            }
        },
        stopTransition: function () {
            var e = this.opts();
            e.slides.stop(!1, !0), e._carouselWrap.stop(!1, !0)
        },
        onDestroy: function () {
            var i = this.opts();
            i._carouselResizeThrottle && e(window).off("resize", i._carouselResizeThrottle), i.slides.prependTo(i.container), i._carouselWrap.remove()
        }
    }
})(jQuery);